import { Controller } from "@hotwired/stimulus"

import { setInputValueWithEvents } from "@/helpers/utils"

export default class extends Controller {
  static targets = ["countInput", "decrementButton", "incrementButton"]
  declare readonly countInputTarget: HTMLInputElement
  declare readonly decrementButtonTarget: HTMLButtonElement
  declare readonly incrementButtonTarget: HTMLButtonElement

  static values = {
    // Negative default so we can detect change on initialization.
    count: { type: Number, default: -1 },
    max: Number,
    min: Number,
    step: Number
  }
  declare countValue: number
  declare readonly maxValue: number
  declare readonly minValue: number
  declare readonly stepValue: number

  countValueChanged(current: number, previous: number): void {
    // Do nothing on initialization
    if (previous < 0) {
      return
    }

    setInputValueWithEvents(this.countInputTarget, current.toString(), ["change"])
    this.setDecrementDisabled()
    this.setIncrementDisabled()

    this.dispatch("countChanged", { detail: { count: this.countValue, max: this.maxValue } })
  }

  decrement(): void {
    this.countValue = Math.max(this.minValue, this.countValue - this.stepValue)
  }

  increment(): void {
    this.countValue = Math.min(this.maxValue, this.countValue + this.stepValue)
  }

  setCountTo(value: number): void {
    this.countValue = Math.max(this.minValue, Math.min(value, this.maxValue))
  }

  private setDecrementDisabled(): void {
    this.decrementButtonTarget.setAttribute(
      "aria-disabled",
      this.countValue - this.stepValue < this.minValue ? "true" : "false"
    )
  }

  private setIncrementDisabled(): void {
    this.incrementButtonTarget.setAttribute(
      "aria-disabled",
      this.countValue + this.stepValue > this.maxValue ? "true" : "false"
    )
  }
}
